import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, computed } from "vue";
import { PropertyFindResult } from "@/types/find/properties/PropertyFindResult";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-property-results',
  props: {
  /**
   * An array containing the search results for properties.
   * Each item in the array represents a property found during the search.
   * @type {PropertyFindResult[]}
   * @required
   */
  data: {
    type: Array as PropType<PropertyFindResult[]>,
    required: true,
  },
  /**
   * Indicates whether a search operation is currently in progress.
   * @type {boolean}
   * @default false
   */
  searching: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Emits an event when a row is clicked.
   * Passes the selected property data to the parent component.
   * @param {PropertyFindResult} e - The clicked row's property data.
   */
  "rowClick",
  /**
   * Emits an event when a row is selected.
   * Sends both the property data and the row index to the parent component.
   * @param {PropertyFindResult} e - The selected row's property data.
   * @param {number} rowIndex - The index of the selected row.
   */
  "rowSelected",
  /**
   * Emits an event when a row is selected adaptively.
   * This can be used for dynamic selection behavior in the UI.
   * @param {PropertyFindResult} e - The adaptively selected row's property data.
   */
  "adaptiveRowSelection",
],
  setup(__props, { emit }) {





/** Handles the grid row click event */
const onRowClick = (e: PropertyFindResult) => emit("rowClick", e);

/** Handles the grid row selected event */
const onRowSelected = (e: PropertyFindResult, rowIndex: number) =>
  emit("rowSelected", e, rowIndex);

// Handles the event triggered when the user clicks on the ... button on a row
const adaptiveRowSelection = (e: PropertyFindResult) =>
  emit("adaptiveRowSelection", e);

const isMobile = computed(() => window.innerWidth <= 768);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GridBase, {
    "data-source": __props.data,
    "id-column-name": "id",
    loading: __props.searching,
    "show-column-filters": false,
    "show-search-panel": false,
    onRowClick: onRowClick,
    onRowSelected: onRowSelected,
    wordWrapEnabled: true,
    onAdaptiveRowSelection: adaptiveRowSelection
  }, {
    columns: _withCtx(() => [
      _createVNode(_unref(DxColumn), {
        "data-field": "address",
        caption: "Address",
        width: isMobile.value ? '200px' : '280px',
        "hiding-priority": 6
      }, null, 8, ["width"]),
      _createVNode(_unref(DxColumn), {
        "data-field": "category.description",
        caption: "Category",
        width: "100px",
        "hiding-priority": 5
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "status.description",
        caption: "Status",
        width: "100px",
        "hiding-priority": 4
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "price",
        caption: "Price",
        "hiding-priority": 3,
        width: "200px"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "owner",
        caption: "Owner",
        "hiding-priority": 2
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "id",
        caption: "ID",
        "hiding-priority": 1
      })
    ]),
    _: 1
  }, 8, ["data-source", "loading"]))
}
}

})